import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import { Eye } from 'react-feather';
import { formatDate } from '../../helpers/dateUtils';
import Table from '../../components/ui/Table';
import envioMailService from '../../services/http/envioEmailService';
import ModalHeaderBody from '../../layouts/modals/ModalHeaderBody';
import BodyRemesa from './BodyRemesa';
import colors from '../../theme/colors';

const AccionesRemesaCell = ({ original, onVerDetalle }) => (
  <button
    type="button"
    onClick={() => onVerDetalle(original)}
    style={{
      display: 'inline-flex', alignItems: 'center', gap: '4px', padding: '4px 10px',
      fontSize: '0.7rem', fontWeight: 600, borderRadius: '6px',
      border: `1px solid ${colors.primary}`, backgroundColor: '#fff',
      color: colors.primary, cursor: 'pointer', transition: 'all 0.15s',
    }}
  >
    <Eye size={12} />
    Ver detalle
  </button>
);
AccionesRemesaCell.propTypes = {
  original: PropTypes.object.isRequired,
  onVerDetalle: PropTypes.func.isRequired,
};

const ListadoEmails = () => {
  const [remesas, setRemesas] = useState([]);
  const [loadingData, setLoadingData] = useState([]);
  const [dataDetail, setDataDetail] = useState(null);
  const [openRemesaDetail, setOpenRemesaDetail] = useState(false);

  const fetchRemesas = async () => {
    setLoadingData(true);

    try {
      const data = await envioMailService.getRemesas();
      setRemesas(data);
    } catch (error) {
      setRemesas([]);
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    fetchRemesas();
  }, []);

  if (loadingData) {
    return (
      <Col className="mt-3" md="12">
        Cargando remesas
      </Col>
    );
  }

  return (
    <>
      <Col className="mt-3" md="12">
        <Table
          columns={[
            {
              Header: 'Centro',
              accessor: 'centro',
              width: 150,
            },
            {
              Header: 'ID',
              accessor: 'IdRemesa',
              width: 100,
            },
            {
              Header: 'Asunto',
              accessor: 'Descripcion',
            },
            {
              Header: 'Fecha emisión',
              accessor: 'FechaEmisionFormatted',
              width: 150,
            },
            {
              Header: 'Fecha envio',
              accessor: 'FechaEnvioFormatted',
              width: 150,
            },
            {
              Header: 'Hora',
              accessor: 'Hora',
              width: 75,
            },
            {
              Header: 'Acciones',
              CellComponent: AccionesRemesaCell,
              cellProps: {
                onVerDetalle: (row) => {
                  setDataDetail(row);
                  setOpenRemesaDetail(true);
                },
              },
              sortable: false,
              filterable: false,
              width: 150,
            },
          ]}
          data={remesas.map((r) => ({
            ...r,
            FechaEmisionFormatted: formatDate(r.FechaEmision, 'dd-MM-yyyy'),
            FechaEnvioFormatted: formatDate(r.FechaEnvio, 'dd-MM-yyyy'),
          }))}
          defaultPageSize={10}
          showPaginationBottom
          className="-striped -highlight mt-5 text-center"
        />
      </Col>

      {openRemesaDetail && (
        <ModalHeaderBody
          open={openRemesaDetail}
          setOpen={setOpenRemesaDetail}
          title={`Detalle de la remesa ${dataDetail.IdRemesa}`}
          size="xl"
        >
          <BodyRemesa remesa={dataDetail} />
        </ModalHeaderBody>
      )}
    </>
  );
};
export default ListadoEmails;
